import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);
  const urlError = params.get('error');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#1a365d' }}>
      <div style={{ background: 'white', borderRadius: '12px', padding: '40px', width: '100%', maxWidth: '400px', margin: '20px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <h1 style={{ textAlign: 'center', color: '#1a365d', marginBottom: '8px', fontSize: '28px' }}>Nucleus</h1>
        <p style={{ textAlign: 'center', color: '#718096', marginBottom: '32px', fontSize: '14px' }}>Hot Hands Sports Dashboard</p>

        {(error || urlError) && (
          <div style={{ background: '#fed7d7', color: '#9b2c2c', padding: '10px', borderRadius: '6px', marginBottom: '16px', fontSize: '13px' }}>
            {error
              || (urlError === 'not_registered' ? 'Account not registered. Contact admin.'
              : urlError === 'deactivated' ? 'This account has been deactivated. Contact admin.'
              : 'Login failed. Try again.')}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="you@example.com" />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="Enter password" />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}
                  style={{ width: '100%', padding: '12px', fontSize: '14px', marginTop: '8px' }}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div style={{ textAlign: 'center', margin: '20px 0', color: '#a0aec0', fontSize: '12px' }}>or</div>

        <a href="/auth/google" className="btn btn-secondary"
           style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '12px', textDecoration: 'none' }}>
          Sign in with Google
        </a>
      </div>
    </div>
  );
}
